




















import { downloadGeojson, PRIVILEGE_KEYS } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import moment from 'moment';


@Component({
    components: {
        Button,
    }
})
export default class DownloadWorkSegments extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {

    @Prop({default() {return []}}) workSegments: Array<object>;
    @Prop({default() {return []}}) selectedWorkSegments: Array<object>;
    @Prop({default() {return []}}) geojsonSegmentsOfWork: Array<object>;
    @Prop({default: ''}) ranchName: string;
    @Prop({default: true}) canDownloadSegments: boolean;
    downloadAllWorkSegments: string = 'Descargar segmentos de trabajo';
    downloadSelectedWorkSegments: string = 'Descargar segmentos de trabajo seleccionados';
    noSegments: string = 'No hay segmentos de trabajo para descargar';
    pendingDownloadWorkSegments: boolean = false;

    getFileName() {
        let actualDate = moment().format('DD-MM-YYYY_HH-mm-ss');
        let fileName = 'segmentos_de_trabajo_chacra_' + this.ranchName + '_' + actualDate
        return fileName;
    }

    get existSegmentsOfWork(){
        if(this.workSegments.length == 0){
            return false
        }
        return true
    }
    get existSelectedWorkSegments(){
        if(this.selectedWorkSegments.length == 0){
            return false
        }
        return true
    }

    get tooltipButton(){
        if(!this.existSegmentsOfWork){
            return this.noSegments
        }

        if(this.existSegmentsOfWork && !this.existSelectedWorkSegments){
            return this.downloadAllWorkSegments
        }

        return this.downloadSelectedWorkSegments
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    downloadWorkSegments(){
        downloadGeojson(
            this.geojsonSegmentsOfWork, 
            this.selectedWorkSegments,
            this.getFileName(),
            ['name']
        );
    }
}
